import React from 'react';
import { getDeviceIcon, getDeviceCategoryLabel } from '../../utils/deviceIcons';

/**
 * High-contrast map pin: brand circle + white glyph.
 * List/sidebar icons stay stroke-only SVGs; map tiles need fill + shadow.
 */
function DeviceMapMarker({ category }) {
  return (
    <div className="map-device-marker" title={getDeviceCategoryLabel(category)}>
      <img
        className="map-device-marker__icon"
        src={getDeviceIcon(category)}
        alt=""
        aria-hidden
      />
    </div>
  );
}

export default React.memo(DeviceMapMarker);
